import { http } from 'utils'

// Talent location state.
const state = {
  locations: []
}

// Talent location state getters.
const getters = {}

// Talent location actions.
const actions = {
  /**
   * Update a talents locations.
   *
   * @return Promise
   */
  updateTalentLocations ({ commit }, { id, payload }) {
    return http.put(`users/${id}/talent_locations`, payload)
  }
}

// Talent location state mutations.
const mutations = {}

// Export our state, getters, actions, and mutations.
export default {
  namespaced: true, state, getters, actions, mutations
}
